import {
  FETCH_ADVFILTER_REQUEST,
  FETCH_ADVFILTER_SUCCESS,
  FETCH_ADVFILTER_FAILURE,
} from "./appoinmentAdvListTypes";

const initialState = {
  loading: false,
  AdvFilterList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADVFILTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ADVFILTER_SUCCESS:
      return {
        loading: false,
        AdvFilterList: action.payload,
        error: "",
      };
    case FETCH_ADVFILTER_FAILURE:
      return {
        loading: false,
        AdvFilterList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
